/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Extension_DescriptionInputs */

const he_seo_extension_description = /** @type {(inputs: Seo_Extension_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התקינו את תוסף Pricedrop החינמי לדפדפן וצפו בהיסטוריית מחירים ישירות בדפי מוצרים של KSP. זמין לכרום, פיירפוקס, אדג׳ וברייב.`)
};

const en_seo_extension_description = /** @type {(inputs: Seo_Extension_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install the free Pricedrop browser extension to see price history directly on KSP product pages. Available for Chrome, Firefox, Edge and Brave.`)
};

/**
* | output |
* | --- |
* | "Install the free Pricedrop browser extension to see price history directly on KSP product pages. Available for Chrome, Firefox, Edge and Brave." |
*
* @param {Seo_Extension_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_extension_description = /** @type {((inputs?: Seo_Extension_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Extension_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_extension_description(inputs)
	return en_seo_extension_description(inputs)
});